import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import ApprovalsService from 'src/services/approvals.service';

export const useBulkApprove = (): UseMutationResult<
  any,
  Error,
  { benefitSummaryIds: string[]; contactApprovalIds: string[]; companyId: string },
  void
> =>
  useMutation(
    (data: { benefitSummaryIds: string[]; contactApprovalIds: string[]; companyId: string }) =>
      ApprovalsService.bulkApprove(data),
    {
      onSuccess: () => {
        AlertAdapter(
          'Changes approved successfully. Already approved or declined selections will be ignored.',
          'success'
        );
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );
